module.exports = __webpack_public_path__ + "img/detailsImg.c23ab917.png";